module.exports = __webpack_public_path__ + "img/privacy-icn.99264917.svg";